import React from 'react'
import './ambassadorCharacteristics.scss'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

const AmbassadorCharacteristics = () => {
  const {
    beAmbassador: { childImageSharp: beAmbassador },
    beAmbassador1: { childImageSharp: beAmbassador1 },
    beAmbassador2: { childImageSharp: beAmbassador2 },
    beAmbassador3: { childImageSharp: beAmbassador3 },
    beAmbassador4: { childImageSharp: beAmbassador4 },
  } = useStaticQuery(graphql`
    {
      beAmbassador: file(name: { eq: "be-ambassador-p" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      beAmbassador1: file(name: { eq: "be-ambassador-1" }) {
        childImageSharp {
          gatsbyImageData
        }
      }

      beAmbassador2: file(name: { eq: "be-ambassador-2" }) {
        childImageSharp {
          gatsbyImageData
        }
      }

      beAmbassador3: file(name: { eq: "be-ambassador-3" }) {
        childImageSharp {
          gatsbyImageData
        }
      }

      beAmbassador4: file(name: { eq: "be-ambassador-4" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const itemsAmbassador = [
    {
      img: beAmbassador1,
      title: 'Tiene un corazón lleno de Loving',
      description:
        'Sus palabras y actitudes en la comunidad de Nosotras solo expresan Loving.',
    },
    {
      img: beAmbassador2,
      title: 'Es fan de la Tecnología Cur-V',
      description:
        'Las Toallas son su producto favorito, y ahora mucho más gracias a la nueva Tecnología Cur-V.',
    },
    {
      img: beAmbassador3,
      title: 'Conoce todo sobre Nosotras',
      description:
        'Comparte con sus amigas y familia todos los beneficios de seguir a Nosotras y usar sus productos.',
    },
    {
      img: beAmbassador4,
      title: 'Es amante de las redes sociales',
      description:
        'No se pierde ni una tendencia y le encanta compartir con el mundo todo lo que es.',
    },
  ]

  return (
    <section className="f-ambassador-characteristics">
      <div className="f-ambassador-characteristics__wrapper">
        <p className="f-ambassador-characteristics__sup-text">
          ¡Siéntete segura, tranquila y <b>sin temor a mancharte</b> gracias a
          la nueva Tecnología Cur-V!
        </p>
        <p className="f-ambassador-characteristics__text desktop">
          Ahora puedes seguir moviéndote y haciendo lo que te gusta con la nueva
          generación de Toallas Nosotras <b>para el día</b>. Si eres fan de las
          redes sociales, te gusta compartir tu conocimiento sobre el período y
          amas nuestra marca, ¡no te puedes perder esta edición!
        </p>

        <div className="f-ambassador-characteristics__items">
          <div className="f-ambassador-characteristics__items__image">
            <GatsbyImage
              objectFit="cover"
              image={getImage(beAmbassador)}
              alt="Ser Embajadora"
              className="f-ambassador-characteristics__items__img"
            />
          </div>

          <p className="f-ambassador-characteristics__text mobile">
            Ahora es el momento de compartirle al mundo{' '}
            <b>por qué el período no te detiene </b> y puedes seguir moviéndote
            y haciendo lo que te gusta con la nueva generación de Toallas
            Nosotras <b>para el día</b>. Si eres fan de las redes sociales, te
            gusta compartir tu conocimiento sobre el período y amas nuestra
            marca, ¡no te puedes perder esta edición!
          </p>
          <h3 className='f-ambassador-characteristics__items__title'>¿Qué identifica a una embajadora?</h3>

          {itemsAmbassador.map((item, i) => {
            return (
              <div
                key={`itemA-${i}`}
                className="f-ambassador-characteristics__item"
              >
                <div className="f-ambassador-characteristics__item__image">
                  <GatsbyImage
                    objectFit="contain"
                    image={getImage(item.img)}
                    alt={item.title}
                    className="f-ambassador-characteristics__item__img"
                  />
                </div>
                <p className="f-ambassador-characteristics__item__title">
                  {item.title}
                </p>

                <p className="f-ambassador-characteristics__item__description">
                  {item.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default AmbassadorCharacteristics
